import DiscussionListState from 'flarum/forum/states/DiscussionListState';
export default class PrivateDiscussionListState extends DiscussionListState {}
flarum.reg.add('fof-byobu', 'forum/states/PrivateDiscussionListState', PrivateDiscussionListState);